import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { EMetroTravelType } from '../../../json_query';
import { tagsSelector } from '../../../selectors/filters/tagsSelector';
import { TTag } from '../../state/tags';
import { IKpIdTag } from '../../state/tags/definitions/kp_id';
import { Tags } from './index';

export const TagsContainer = connect(
  (state: IAppState) => {
    const jsonQuery = (state.filters.backup && state.filters.backup.jsonQuery) || state.filters.jsonQuery;
    const tags = tagsSelector(state);
    const kpIdTag = tags.find(({ type }) => type === 'kp-id') as IKpIdTag;

    if (kpIdTag && state.villageName) {
      kpIdTag.text = state.villageName;
    }

    return {
      userIsAuthenticated: state.user.isAuthenticated,
      isFitInOneLineEnabled: state.filters.tagsOptions.isFitInOneLineEnabled,
      tags,
      travelType: (jsonQuery.only_foot && jsonQuery.only_foot.value) || EMetroTravelType.Any,
      travelTime: jsonQuery.foot_min && jsonQuery.foot_min.value.lte,
      jsonQuery,
    };
  },
  (dispatch: Dispatch) => ({
    onTagDeleted: (tag: TTag, index: number) => {
      dispatch({
        type: 'filters/tags/TAG_REMOVED',
        tag,
        index,
      });
    },
    onAllTagsDeleted: () => {
      dispatch({
        type: 'filters/tags/ALL_TAGS_REMOVED',
      });
    },
  }),
)(Tags);
